export const cover = {
    uk : {
        coverFrom :'\u00A327',
        annualCoverFrom : '\u00A3199',
        cancellation : '\u00A37,000',
        medical : '\u00A310 million',
        personalLiability : '\u00A32 million',
        personalAccident : '\u00A330,000',
        baggage : '\u00A32,000',
        legalExpenses : '\u00A350,000',
        personalMoney : '\u00A3500',
        passportVisa : '\u00A3500',
        travelDelay : '\u00A37,000',
        extend : '\u00A350,000',
    },
    ie : {
        coverFrom : '\u20AC23',
        annualCoverFrom : '\u20AC23',
        cancellation : '\u20AC6,000',
        medical : '\u20AC10 million',
        personalLiability : '\u20AC2 million',
        personalAccident : '\u20AC40,000',
        baggage : '\u20AC2,500',
        legalExpenses : '\u20AC50,000',
        personalMoney : '\u20AC600',
        passportVisa : '\u20AC300',
        travelDelay : '\u20AC2,400',
        extend : '\u20AC10,000',
    },
    ukBackpacker : {
        cancellation : '\u00A32,000',
        medical : '\u00A310 million',
        personalLiability : '\u00A32 million',
        personalAccident : '\u00A315,000',
        baggage : '\u00A31,500',
        legalExpenses : '\u00A310,000',
        personalMoney : '\u00A3500',
        passportVisa : '\u00A3300',
        travelDelay : '\u00A32,400'
    },
    ieBackpacker : {
        cancellation : '\u20AC2,000',
        medical : '\u20AC10 million',
        personalLiability : '\u20AC2 million',
        personalAccident : '\u20AC15,000',
        baggage : '\u20AC1,500',
        legalExpenses : '\u20AC10,000',
        personalMoney : '\u20AC500',
        passportVisa : '\u20AC250',
        travelDelay : '\u20AC1,000'
    }
}